// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDDWBIR8DnTdIVzrIzdpIG8dL1vpZkuB9o",
  authDomain: "crypto-pub.firebaseapp.com",
  projectId: "crypto-pub",
  storageBucket: "crypto-pub.appspot.com",
  messagingSenderId: "1062987027981",
  appId: "1:1062987027981:web:37744d0c3af164997a6744"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default firebaseConfig;